import { Skeleton, Stack, useTheme } from "@mui/material";

interface IBybListItemSkeleton {
  avatar?: boolean;
  reward?: boolean;
  subtitle?: boolean;
  rank?: boolean;
}

const BybListItemSkeleton = ({ avatar, reward, subtitle, rank }: IBybListItemSkeleton) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        paddingX: theme.spacing(2.5),
        paddingY: theme.spacing(1.25),
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
        }}
      >
        {rank && (
          <Stack
            width={28}
            sx={{
              alignItems: "center",
            }}
          >
            <Skeleton variant="circular" width={14} height={14} />
          </Stack>
        )}
        {avatar && <Skeleton variant="circular" width={40} height={40} />}
        {reward && <Skeleton variant="rounded" width={40} height={40} />}
      </Stack>
      <Stack
        spacing={1}
        sx={{
          flexGrow: 1,
        }}
      >
        <Skeleton variant="text" width={250} />
        {subtitle && <Skeleton variant="text" width={200} />}
      </Stack>
    </Stack>
  );
};

export default BybListItemSkeleton;
